import { Id, ModuleVariant } from '@ess/jg-rule-executor';
import {
  GetAllModuleCategorySettings_allModuleCategorySettings_blueprints,
} from '@src/app/generated/GetAllModuleCategorySettings';
import { JsonProperty } from 'ta-json';

export class PortalCategoryBlueprint {
  @JsonProperty() name: string;
  @JsonProperty() status: string;
  @JsonProperty() moduleVariantIds: Id<ModuleVariant>[];
  @JsonProperty() orderWeight: number;

  constructor(
    name?: string,
    status?: string,
    moduleVariantIds?: Id<ModuleVariant>[],
    orderWeight?: number
  ) {
    this.name = name;
    this.status = status;
    this.moduleVariantIds = moduleVariantIds;
    this.orderWeight = orderWeight;
  }

  static fromGql(gql: GetAllModuleCategorySettings_allModuleCategorySettings_blueprints): PortalCategoryBlueprint {
    return new PortalCategoryBlueprint(
      gql.name,
      gql.status,
      gql.moduleVariantIds,
      gql.orderWeight
    );
  }
}
